import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { TIMEOUT_DURATION_UPLOAD_IMAGE } from '../../constant/global/Config'
import { showAlert } from '../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorFileUpload = () => {
  const { t } = useTranslation()
  const uploadFile = useCallback(
    (payload, callback) => {
      payload = {
        ...payload,
      }

      const timeout = setTimeout(() => {
        showAlert({
          icon: 'error',
          message: t('response_message.internet_connection_error_upload_image'),
          timer: false,
          reload: true,
        })
      }, TIMEOUT_DURATION_UPLOAD_IMAGE)

      let response = ApiService.formRequest('/storage-file/upload', payload, (response) => {
        clearTimeout(timeout)
        if (response.status_code === 200) {
          callback(response)
        }
      })

      return response
    },
    [t],
  )

  return { uploadFile }
}

export default InteractorFileUpload
